import { render, staticRenderFns } from "./charges-table.vue?vue&type=template&id=1046de0a&"
import script from "./charges-table.vue?vue&type=script&lang=js&"
export * from "./charges-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports